import React from 'react';

const Resources = () => (
    <main class="min-vh-100">
        <section>
            <div class="container-lg my-5">
                <div class="row">
                <div class="col">
                    <div class="p-4">
                    <h1>Resources</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis. Amet nisl suscipit adipiscing bibendum est ultricies integer quis. Tincidunt dui ut ornare lectus sit amet est placerat. Et netus et malesuada fames ac turpis egestas. Volutpat est velit egestas dui.</p>
                    </div>
                </div>
                </div>
                <div class="row">
                <div class="col">
                    <div class="p-4">
                    <h2>Origami.org</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <p>Go to: <a class = "text-dark" href="https://www.origami.org/">https://www.origami.org</a></p>
                    </div>
                </div>
                </div>
                <div class="row">
                <div class="col">
                    <div class="p-4">
                    <h2>Origami-make.org</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <p>Go to: <a class = "text-dark" href="https://www.origami-make.org/">https://www.origami-make.org</a></p>
                    </div>
                </div>
                </div>
                <div class="row">
                <div class="col">
                    <div class="p-4">
                    <h2>The Origami Papershop</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <p>Go to: <a class = "text-dark" href="https://www.theorigamipapershop.com/">https://www.origami-make.org</a></p>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </main>
  );
  
  export default Resources;
